import { render, staticRenderFns } from "./FuncionarioForm.vue?vue&type=template&id=bfe8e4e6&scoped=true"
import script from "./FuncionarioForm.vue?vue&type=script&lang=ts"
export * from "./FuncionarioForm.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bfe8e4e6",
  null
  
)

export default component.exports